import { render, staticRenderFns } from "./FeatureExtraForm.vue?vue&type=template&id=01302ed4&scoped=true"
import script from "./FeatureExtraForm.vue?vue&type=script&lang=js"
export * from "./FeatureExtraForm.vue?vue&type=script&lang=js"
import style0 from "./FeatureExtraForm.vue?vue&type=style&index=0&id=01302ed4&prod&lang=less&scoped=true"
import style1 from "./FeatureExtraForm.vue?vue&type=style&index=1&id=01302ed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01302ed4",
  null
  
)

export default component.exports